/* @flow */
import {
  AD_LIMIT_DEFAULT,
  AD_LIMIT_PAID_CONTENT
} from './__constants__';
import getBodySectionAdList from './getBodySectionAdList';
import getSlideshowSectionAdList from './getSlideshowSectionAdList';

import type {
  SectionAdList,
  SectionsObject
} from './__types__';

export default (
  { body, slideshow }: SectionsObject,
  isPaidContent: bool
): { body: SectionAdList, slideshow: SectionAdList } => {
  const adLimit = isPaidContent ? AD_LIMIT_PAID_CONTENT : AD_LIMIT_DEFAULT;
  const allSections = [...body, ...slideshow];
  const numSections = allSections.length;
  const bottomSection = allSections[numSections - 1];
  const options = { adLimit, numSections, bottomSection, isPaidContent };

  const [bodySectionAdList, adCount] = getBodySectionAdList({
    sections: body,
    ...options
  });
  const [slideshowSectionAdList] = getSlideshowSectionAdList({
    adCount,
    sectionCount: body.length + 1,
    sections: slideshow,
    ...options
  });

  return {
    body: bodySectionAdList,
    slideshow: slideshowSectionAdList
  };
};

